import Tool from '../../common/tool';
import { openKefu } from '../../common/openKefu';
var FooterMain = /** @class */ (function () {
    function FooterMain() {
        this.footerDom = document.getElementById('daetool-footer');
        this.serviceDom = document.getElementById('daetool-service');
        this.init();
    }
    FooterMain.prototype.init = function () {
        this.footerEvent();
        this.serviceEvent();
        this.closeActivityEntry();
        this.qqEvent();
    };
    // 七鱼在线客服（与金舟 item-link-btn 逻辑一致）
    FooterMain.prototype.footerEvent = function () {
        var kefuBtns = Tool.$_selectAll(this.footerDom, '.item-link-btn');
        kefuBtns.forEach(function (item) {
            var onOpenKefu = function () {
                openKefu();
            };
            item.addEventListener('click', onOpenKefu);
            item.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onOpenKefu();
                }
            });
        });
    };
    FooterMain.prototype.serviceEvent = function () {
        if (!this.serviceDom)
            return;
        var toTopBtn = Tool.$_select(this.serviceDom, '.to-top-btn');
        if (toTopBtn) {
            var scrollToTop_1 = function () {
                window.scrollTo({
                    left: 0,
                    top: 0,
                    behavior: 'smooth',
                });
            };
            toTopBtn.addEventListener('click', scrollToTop_1);
            toTopBtn.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    scrollToTop_1();
                }
            });
        }
    };
    FooterMain.prototype.qqEvent = function () {
        var _loop_1 = function (index) {
            var qqAllDom = document.querySelector(".go-url-".concat(index));
            if (!qqAllDom)
                return "continue";
            qqAllDom.addEventListener('click', function () {
                var url = qqAllDom.getAttribute('data-dUrl');
                if (url)
                    window.open(url, '_blank');
            });
        };
        for (var index = 0; index < 3; index++) {
            _loop_1(index);
        }
    };
    FooterMain.prototype.closeActivityEntry = function () {
        var hasActivityEntry = document.body.contains(document.getElementsByClassName('goto-activity-box')[0]);
        if (hasActivityEntry) {
            var closeActivityBtn = document.querySelector('.close-activity');
            closeActivityBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var ActivityEntryBox = document.querySelector('.goto-activity-box');
                ActivityEntryBox.classList.add('hide');
            });
        }
    };
    return FooterMain;
}());
export default FooterMain;
